export interface IdDescription {
  id: string;
  description: string;
}
